// Reason: workspace.status stays 'active' even when the subscription is pastDue/locked — the table and detail sidebar both derive the effective state from here so they always agree

export const LOCK_REASON_LABELS = {
  subscription_ended: 'Subscription ended',
  payment_failed: 'Payment failed',
  admin_locked: 'Locked by admin',
  plan_change_pending_payment: 'Plan change pending payment',
  grace_period_expired: 'Grace period expired',
  payment_required: 'Payment required'
};

const WORKSPACE_STATUS_STATES = {
  active: { label: 'Active', color: 'success' },
  trial: { label: 'Trial', color: 'info' },
  inactive: { label: 'Inactive', color: 'secondary' }
};

export const getWorkspaceEffectiveState = (workspace, subscription) => {
  if (workspace?.isDeleted || workspace?.computedStatus === 'deactivated') return { label: 'Deactivated', color: 'danger' };
  if (workspace?.status === 'suspended') return { label: 'Paused', color: 'warning' };
  if (subscription?.isLocked) return { label: 'Locked', color: 'danger' };
  if (subscription?.status === 'pastDue' || subscription?.status === 'unpaid') return { label: 'Past Due', color: 'warning' };
  if (subscription?.status === 'canceled') return { label: 'Canceled', color: 'secondary' };
  if (subscription?.status === 'incomplete' || subscription?.status === 'pending_payment') return { label: 'Payment Pending', color: 'warning' };
  return WORKSPACE_STATUS_STATES[workspace?.status] || { label: workspace?.status || 'Active', color: 'success' };
};
